import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_MOBILE_NOTIFICATIONS_CONFIG = defineFcm('mobile_notifications_config')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				delete_notifications_older_than_days: { type: 'number' },
			},
		}),
	)
	.withDefault(undefined)
	.toConfig();
